/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";

import InputSelect from "../../../../../components/Input-select";
import Spinner from "../../../../../components/Spinner/index";
import InputFormik from "../../../../../components/InputFormik";

import "./index.scss";
import useFormStore from "../store/useStore";
import { useEffect, useState } from "react";
import { getTech, postTech } from "../../../../Technologies/service";
import useAuthData from "../../../../../hook/useAppData";
import { getJobRoles, postJobRoles } from "../../../../JobsRoles/service";
import { serviceUsers } from "../../../service";
import { IObjCheckBoxDTO } from "../../../model";
import { calculos } from "./libs";
import CheckboxesTags from "../../../../../components/CheckboxSelected";
import { remask } from "../../../../../libs/remask-mask";
import { orderByName } from "../../../../../libs/orderList";
import Input from "../../../../../components/Input";
import { Toaster } from "react-hot-toast";
import { ModalPopUp } from "../../../../../components/ModalPopUp";
import { AddNewFieldSelect } from "../../../../../components/AddNewFieldModal/AddNewFieldSelect";
import { postCostCenter } from "../../../../CostCenter/service";
import { postSeniority } from "../../../../Seniority/service";
import { toastWarn } from "../../../../../components/Toast";

const regime = [
  { id: 1, name: "CLT" },
  { id: 2, name: "PJ" },
];

const regime_2 = [{ id: 2, name: "PJ" }];

const NF = [
  { id: 1, name: "Por mês" },
  { id: 2, name: "Por hora" },
];

const listIsBilled = [
  { value: false, name: "Não faturado" },
  { value: true, name: "Faturado" },
];

interface ISeniority {
  id: number;
  name: string;
}

interface IModalNewFieldSelect {
  label: string;
  value: number;
  name: string;
  action: () => void;
  exit: () => void;
  save: (body, token: string) => Promise<any>;
  objSave: (value) => any;
}

function FormProfessionalData() {
  const { updateValue, contract_type, setContract_Type, setUpdateValueObj } = useFormStore();
  const { modo, setState } = useFormStore();
  const { saveOrSchedule, dateSchedule, handleSetDate } = useFormStore();
  const {
    needSpinner,
    selectedTech,
    setSelectedTech,
    selectedJob_roles,
    setSelectedJob_roles,
    selectedCostCenter,
    setSelectedCostCenter,
    setUpdateValue,
    listProfile,
    tax,
  } = useFormStore();
  const { token, corporationId } = useAuthData();
  const [techs, setTechs] = useState([] as any[]);
  const [jobRoles, setJobRoles] = useState([] as any[]);
  const [costCenter, seConstCenter] = useState([] as any[]);
  const [seniority, setSeniority] = useState([] as any[]);
  const [needSpinnerLocal, setNeedSpinnerLocal] = useState(true);
  const [warnHourBase, setWarnHourBase] = useState(true);
  const [modalNewFieldSelect, setModalNewFieldSelect] = useState<IModalNewFieldSelect>();

  useEffect(() => {
    getTechnology();
    getJobRolesData();
    getCostCenter();
    getSeniority();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!warnHourBase) setWarnHourBase(true);
    }, 10000);
  }, [warnHourBase]);

  useEffect(() => {
    if (techs?.length && costCenter?.length && jobRoles?.length && seniority?.length) setNeedSpinnerLocal(false);
    setTimeout(() => {
      setNeedSpinnerLocal(false);
    }, 1000);
  }, [techs, costCenter, jobRoles, seniority]);

  async function getSeniority() {
    const res = await serviceUsers.getSeniority(token);
    const data = seniorityDTO(res);
    setSeniority(data);
  }

  function getCostCenter() {
    serviceUsers.getCenterOfCust(token).then((res) => {
      const data = convertIdOfIndex(res, selectedCostCenter);
      seConstCenter(data);
    });
  }

  async function getTechnology() {
    const res = await getTech(token);
    const data = convertIdOfIndex(res, selectedTech);
    setTechs(data);
  }

  function getJobRolesData() {
    getJobRoles(token)?.then((res: any) => {
      const data = convertIdOfIndex(res, selectedJob_roles);
      setJobRoles(data);
    });
  }

  function seniorityDTO(arr: any[]) {
    const arrOrderById = orderByName(arr, "seniority_id", "number");
    return arrOrderById?.map((field: ISeniority) => {
      return {
        id: field.id,
        name: field.name,
      };
    });
  }

  function convertIdOfIndex(arr: any[], arrVerefy: any[]): IObjCheckBoxDTO[] {
    const idFields = returnIdFieldsSelecteds(arrVerefy);

    if (arrVerefy?.length)
      return arr?.map((field: any, index: number) => {
        return {
          ...field,
          checked: idFields.includes(field.id),
          idField: field.id,
          id: index,
        };
      });

    return arr?.map((field: any, index: number) => {
      return {
        ...field,
        checked: false,
        idField: field.id,
        id: index,
      };
    });
  }

  function returnIdFieldsSelecteds(arrVerefy: any) {
    return arrVerefy?.map((verefy: any) => verefy.id);
  }

  function handleBlurEndDate(event: any) {
    if (!!!event.target.value) return setState(false);
    if (!!event.target.value) return setState(true);
    setState((oldState: boolean) => !oldState);
  }

  function closeModal() {
    setUpdateValue({ name: modalNewFieldSelect?.name, value: 0 });
    setModalNewFieldSelect(undefined);
  }

  async function closeModalList() {
    setModalNewFieldSelect(undefined);
  }

  return (
    <>
      <Toaster toastOptions={{ duration: 3000 }} />
      <ModalPopUp
        title={modalNewFieldSelect?.label}
        status={!!modalNewFieldSelect?.value}
        onClickCancel={() => closeModal()}
        className="modal-new-field-select"
      >
        <AddNewFieldSelect info={modalNewFieldSelect} />
      </ModalPopUp>
      <Spinner status={needSpinner || needSpinnerLocal}>
        <div className="collaboratorContainer">
          <div className="title-form form-box-title">
            {modo === "create" ? (
              <h1 className="align-self-end">Adicionar dados profissionais - {updateValue.name || "profissional"}</h1>
            ) : (
              <h1 className="align-self-end">Atualizar dados profissionais - {updateValue.name || "profissional"}</h1>
            )}
            {saveOrSchedule == "schedule" && (
              <div className="schuduleContainer">
                <div className="calendar">
                  <Input label="Data Agendamento" name="teste" placeholder="" value={dateSchedule} setValue={handleSetDate} type="date" />
                </div>
              </div>
            )}
          </div>

          <Formik initialValues={updateValue.data_professional} onSubmit={() => {}}>
            {(props) => (
              <form className="form-container box-form title-form" onSubmit={props.handleSubmit}>
                <div className="row box-row">
                  <InputFormik
                    className="form-input"
                    label={updateValue.pay_config == "1" ? "Remuneração Mensal" : "Valor em rate/hora"}
                    name={updateValue.pay_config == "1" ? "monthly_pay" : "hourly_pay"}
                    onChange={(e: any) => {
                      setUpdateValueObj("data_professional", e.target);
                      props.handleChange(e);
                      if (!updateValue?.hourBase && warnHourBase) {
                        setWarnHourBase(false);
                        toastWarn(
                          `Selecione uma hora base para fazer o cálculo ${
                            updateValue.pay_config == "1" ? "de Remuneração Mensal" : "de Valor em rate/hora"
                          }`,
                        );
                      }
                    }}
                    onBlur={props.handleBlur}
                    value={updateValue.pay_config == "1" ? props.values.monthly_pay : props.values.hourly_pay}
                    placeholder={updateValue.pay_config == "1" ? "Remuneração Mensal" : "Valor em rate/hora"}
                    type="text"
                    required={false}
                    autofocus={false}
                    maxlength="7"
                  />
                  <InputFormik
                    className="form-input"
                    label={
                      updateValue.pay_config != "1"
                        ? "Remuneração Mensal" + " - apenas visualização"
                        : "Valor em rate/hora" + " - apenas visualização"
                    }
                    name="hourly_pay"
                    onChange={(e: any) => {
                      setUpdateValueObj("data_professional", e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={calculos(
                      props.values,
                      updateValue.pay_config == "1" ? "/" : "*",
                      updateValue.pay_config == "1" ? "monthly_pay" : "hourly_pay",
                      updateValue?.hourBase || undefined,
                    )}
                    placeholder={updateValue.pay_config != "1" ? "Remuneração Mensal" : "Valor em rate/hora"}
                    type="text"
                    required={false}
                    autofocus={true}
                    disabled={true}
                  />
                </div>
                <div className="row box-row">
                  <InputFormik
                    className="form-input"
                    label="Data admissão"
                    name="beginnig_at"
                    onChange={(e: any) => {
                      setUpdateValueObj("data_professional", e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={
                      props.values.beginnig_at !== "" && props.values.beginnig_at
                        ? remask(props.values.beginnig_at, ["99/99/9999"])
                        : props.values.beginnig_at
                    }
                    placeholder="DD/MM/AAAA"
                    type="text"
                    required={false}
                    autofocus={false}
                    maxlength="10"
                  />
                  <InputFormik
                    className="form-input"
                    label="Data demissão"
                    name="end_date"
                    onChange={(e: any) => {
                      setUpdateValue(e.target);
                      props.handleChange(e);
                    }}
                    onBlur={(e) => handleBlurEndDate(e)}
                    value={updateValue.end_date !== "" && updateValue.end_date ? remask(updateValue.end_date, ["99/99/9999"]) : updateValue.end_date}
                    placeholder="DD/MM/AAAA"
                    type="text"
                    required={false}
                    autofocus={false}
                    maxlength="10"
                  />
                </div>
                <div className="row box-row">
                  <CheckboxesTags
                    label="Selecionar Centro de Custos"
                    listOptions={costCenter}
                    setState={setSelectedCostCenter}
                    placeholder="Centro de Custos"
                    add={{ name: "cost_center", label: "+ Novo Centro de Custo", value: -1 }}
                    setAdd={(e) =>
                      setModalNewFieldSelect({
                        label: "Novo Centro de Custo",
                        value: e?.id,
                        name: e.name,
                        action: () => {
                          getCostCenter();
                          setNeedSpinnerLocal(true);
                        },
                        exit: closeModalList,
                        save: (body, token) => postCostCenter(body, token),
                        objSave: (value) => {
                          return { name: value };
                        },
                      })
                    }
                  />
                  <CheckboxesTags
                    label="Selecionar Tecnologia"
                    listOptions={techs}
                    setState={setSelectedTech}
                    add={{ name: "technology", label: "+ Nova Tecnologia", value: -1 }}
                    setAdd={(e) =>
                      setModalNewFieldSelect({
                        label: "Nova Tecnologia",
                        value: e?.id,
                        name: e.name,
                        action: () => {
                          getTechnology();
                          setNeedSpinnerLocal(true);
                        },
                        exit: closeModalList,
                        save: (body, token) => postTech(body, token),
                        objSave: (value) => {
                          return { technology: value };
                        },
                      })
                    }
                    placeholder="Tecnologias"
                  />
                </div>
                <div className="row box-row">
                  <CheckboxesTags
                    label="Selecionar cargo"
                    listOptions={jobRoles}
                    setState={setSelectedJob_roles}
                    limit={2}
                    placeholder="Cargos"
                    add={{ name: "job_role", label: "+ Novo Cargo", value: -1 }}
                    setAdd={(e) =>
                      setModalNewFieldSelect({
                        label: "Novo Cargo",
                        value: e?.id,
                        name: e.name,
                        action: () => {
                          getJobRolesData();
                          setNeedSpinnerLocal(true);
                        },
                        exit: closeModalList,
                        save: (body, token) => postJobRoles(body, token),
                        objSave: (value) => {
                          return { jobRole: value };
                        },
                      })
                    }
                  />
                  <InputSelect
                    className="form-input select-contract-type"
                    name="contract_type"
                    placeholder="Selecionar"
                    label="Regime de contratação"
                    onChange={(e: any) => {
                      setContract_Type(e.target.value);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    required={true}
                    value={contract_type}
                    list={corporationId === 1 ? regime : regime_2}
                    disabled={corporationId === 1 ? false : true}
                  />
                </div>
                <div className="row box-row">
                  <InputSelect
                    className="form-input"
                    name="profile"
                    label="Perfil"
                    placeholder="Selecionar"
                    onChange={(e: any) => {
                      setUpdateValue(e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={updateValue.profile}
                    required={true}
                    list={listProfile}
                  />

                  <InputSelect
                    className="form-input select-seniority"
                    name="seniority"
                    label="Senioridade"
                    onChange={(e: any) => {
                      if (+e.target.value === -1)
                        setModalNewFieldSelect({
                          label: "Nova Senioridade",
                          value: +e.target.value,
                          name: e.target.name,
                          action: getSeniority,
                          exit: closeModal,
                          save: (body, token) => postSeniority(body, token),
                          objSave: (value) => {
                            return { name: value };
                          },
                        });
                      setUpdateValue(e.target);
                      props.handleChange(e);
                    }}
                    addNewField={{ label: "Nova Senioridade", value: -1 }}
                    onBlur={props.handleBlur}
                    value={updateValue.seniority}
                    list={seniority}
                    onClick={(e) => {
                      if (!seniority?.length) {
                        setModalNewFieldSelect({
                          label: "Nova Senioridade",
                          value: +e?.target?.value,
                          name: e?.target?.name,
                          action: getSeniority,
                          exit: closeModal,
                          save: (body, token) => postSeniority(body, token),
                          objSave: (value) => {
                            return { name: value };
                          },
                        });
                      }
                    }}
                  />
                  <InputSelect
                    className="form-input"
                    name="isBilled"
                    label="Faturado"
                    placeholder="Selecionar"
                    onChange={(e: any) => {
                      setUpdateValue(e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={updateValue.isBilled}
                    list={listIsBilled}
                  />
                </div>
                <div className="row box-row">
                  <InputSelect
                    className="form-input"
                    onChange={(e: any) => {
                      setUpdateValueObj("data_professional", { name: e?.target?.name, value: +e?.target?.value });
                      props.handleChange(e);
                    }}
                    placeholder="Selecione"
                    name="type_tax_id"
                    label="Selecione o Imposto"
                    list={tax}
                    value={updateValue?.data_professional?.type_tax_id}
                  />
                  <InputSelect
                    className="form-input"
                    name="pay_config"
                    label="Selecione o tipo de Pagamento"
                    onChange={(e: any) => {
                      setUpdateValue(e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={updateValue.pay_config}
                    list={NF}
                  />
                  <InputFormik
                    className="form-input input-hour-base"
                    label="Hora Base"
                    name="hourBase"
                    onChange={(e: any) => {
                      setUpdateValue(e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={updateValue.hourBase}
                    placeholder="Digite a hora base"
                    type="number"
                  />
                </div>
              </form>
            )}
          </Formik>
        </div>
      </Spinner>
    </>
  );
}

export default FormProfessionalData;
